const studies = {
  completion_header: {
    default: "Something went wrong",
    qualified:
      "Congratulations! You have successfully completed the survey",
    non_qualified: "You did not qualify for this survey",
    out_of_quota:
      "This survey has reached the limit and was closed",
  },
};

export default studies;
